/* eslint-disable */
import http from 'common-module/src/util/http';

export const saveWidgetConfig = async (data) => {
  return http.post('/workflow', data);
};

export const listDashboard = async () => {
  return http.post('/sys-home/list', {});
};

export const addDashboard = async (data) => {
  return http.post('/sys-home/add', data);
};

export const copyDashboard = async (data, showError = true) => {
  return http.post('/sys-home/copy', data, { showError: showError });
};

export const updateDashboard = async (data) => {
  return http.post('/sys-home/update', data);
};

export const deleteDashboard = async (id) => {
  return http.post('/sys-home/delete-page', { id });
};

export const pageListAvailableWidget = async (pageNumber, pageSize, category) => {
  return http.post('/sys-home/page-list/widget-available', { pageNumber, pageNum: pageNumber, pageSize, category });
};

export const addWidget = async (data) => {
  return http.post('/sys-home/add/widget', data);
};

export const updateWidget = async (data, showError = true) => {
  return http.post('/sys-home/update/widget', data, { showError: showError });
};

export const deleteWidget = async (data) => {
  return http.post('/sys-home/delete/widget', data);
};

export const listWidget = async (dashboardId, showError = true) => {
  return http.post('/sys-home/list/widget', { id: dashboardId }, { showError: showError });
};

// 获取环形图配置聚合信息
export const getBugWidgetConfig = async () => {
  return http.post('/sys-home/get/bug-widget-config');
};

// 获取燃尽图、累积流图配置聚合信息
export const getBurnDownConfig = async () => {
  return http.post('/sys-home/get/burn-down-config');
};

export const getTodoPriorityList = async () => {
  return http.post('/priority/list');
};

export const getListStateCategory = async () => {
  return http.post('/workflow/state/list-state-category');
};

export const addTodo = async (params) => {
  return http.post('/todo-list/add', params);
};

export const updateTodo = async (params) => {
  return http.post('/todo-list/update', params);
};

export const deleteTodo = async ({ id }) => {
  return http.post('/todo-list/delete', { id });
};

export const getTodoDetail = async ({ id }) => {
  return http.post('/todo-list/detail', { id });
};

export const getTodoList = async (params) => {
  return http.post('/sys-home/get/todo-list-data', params);
};

export const getTodoProjectList = async () => {
  return http.post('/sys-home/get/project/list');
};

export const updateTodoStatus = async (params) => {
  return http.post('/todo-list/update-status', params);
};

export const getTodoNextState = async (params) => {
  return http.post('/todo-list/next-state-list', params);
};

export const getTodoListConfig = async (params) => {
  return http.post('/sys-home/get/todo-list-config', params);
};

/**
 * 更新事项
 * @param id 事项ID
 * @param changes 更新内容
 * @returns {Promise<*>}
 */
export const updateIssue = async (id, changes) => {
  return http.post('/issue/update', { id, data: changes });
};

/**
 * 获取优先级列表
 * @param id 项目id
 * @returns {Promise<*>}
 */
export const getPriorityList = async (projectId) => {
  return http.post('priority/list/project-id', { projectId });
};

/**
 * 更新待办优先级
 * @returns {Promise<*>}
 */
export const updatedTodoPriority = async (id, priority) => {
  return http.post('/todo-list/update-priority', { id, priority });
};

/**
 * 更新截止时间
 * @returns {Promise<*>}
 */
export const updatedTodoDueDate = async (id, dueDate) => {
  return http.post('/todo-list/update-due-date', { id, dueDate });
};

/**
 * 完成页面-分页查询已完成的待办事项
 * @returns {Promise<*>}
 */
export const pageFinishTodoList = async (params) => {
  return http.post('/sys-home/page-finish-todo-list', params);
};

/**
 * 日报总结页面-查询昨日工作报告总结数据
 * @returns {Promise<*>}
 */
export const getTodoYesterdayReport = async () => {
  return http.post('/work-report/yesterday-report');
};

/**
 * 日报总结页面-保存某一天日总结的报告备注内容
 * @returns {Promise<*>}
 */
export const saveReportRemark = async (remark, reportDate) => {
  return http.post('/work-report/save-report-remark', { remark, reportDate });
};

/**
 * 日报总结页面-查询某一天日总结的报告备注内容
 * @returns {Promise<*>}
 */
export const getReportRemark = async (reportDate) => {
  return http.post('/work-report/get-report-remark', { reportDate });
};

/**
 * 个人待办转项目事项
 * @returns {Promise<*>}
 */
export const todoListConvertIssue = async data => {
  return http.post('/todo-list/convert-issue', data);
};

/**
 * 项目编号获取问题类型列表选择器
 * @returns {Promise<*>}
 */
export const getIssueTypeList = async (projectId) => {
  return http.post('/issue-type/list-selector/project-id', { projectId });
};

/**
 * 获取状态列表
 * @returns {Promise<*>}
 */
export const getIssueSelectOptions = async (issueTypeId, projectId) => {
  return http.post('/issue/select-options', { issueTypeId, projectId });
};

/**
 * 根据工作事项ID同步数据
 * @returns {Promise<*>}
 */
export const syncIssueForTodoList = async (id) => {
  return http.post('/todo-list/sync-issue', { id });
};

/**
 * 删除附件
 * @param id 附件id
 * @returns {Promise<*>}
 */
export const removeAttachment = async data => {
  return http.post('sys-file/delete', data);
};
/**
 * 获取小程序二维码
 * @returns {Promise<*>}
 */
export const getQrCode = async () => {
  return http.get('/wx/user/create-qrcode');
};


// 取最近访问的看板配置信息,保存看板组件时
// export const getDefaultKanbanConfig = async () => {
//   return http.post('/sys-home/get/default-kanban-config');
// };
export const getDefaultKanbanConfig = async () => {
  return http.post('/kanban-grid/default-kanban-widget-assemble', {});
};

// 指定项目获取看板组件筛选条件
export const getProjectKanbanConfig = async (data) => {
  return http.post('sys-home/get/project-kanban-config', data);
};

// 仪表盘排序
export const dashBoardSort = async (data) => {
  return http.post('/sys-home/sort/home-page', data);
};

// 获取全部仪表盘模板信息
export const sysHomeTemplatePageTemplateListAll = async (data) => {
  return http.post('/sys-home-template/page-template/list/all', data);
};

// 添加仪表盘模板喜欢
export const sysHomeTemplatePageTemplateFavorite = async (data) => {
  return http.post('/sys-home-template/page-template/favorite', data);
};

// 取消仪表盘模板喜欢
export const sysHomeTemplatePageTemplateFavoriteCancel = async (data) => {
  return http.post('/sys-home-template/page-template/favorite-cancel', data);
};

// 根据仪表盘模板id获取仪表盘模板以及组件模板初始化信息
export const sysHomeTemplateId = async (data) => {
  return http.post('/sys-home-template/get', data);
};

export const sysHomeTemplateGetTemplate = async(data) => {
  return http.post('/sys-home-template/get-template', data);
};

// 根据仪表盘模板id获取仪表盘模板以及组件模板初始化信息
export const syshomeFromconfigAdd = async (data) => {
  return http.post('/sys-home/from-config/add', data);
};

// 获取选定的仪表盘分享链接
export const getShareLink = async (data) => {
  return http.post('/dashboard-share/get-share-link', data);
};

// 发送仪表盘列表分享链接给指定成员
export const sendShareToUser = async (data) => {
  return http.post('/dashboard-share/send-share-to-user', data);
};

// 通过分享链接进入仪表盘页面
export const getDashboardShare = async (data) => {
  return http.get('/dashboard-share/enter', data, { showError: data.showError });
};

// 获取仪表盘列表分享详情（用来回选已经操作过的仪表盘或者用户）
export const getSpaceShareDetails = async (data) => {
  return http.post('/dashboard-share/query-space-share-details', data);
};

// 用户可选择的组织角色列表
export const getOrgUserList = async (data) => {
  return http.post('/org-user/user-list', data);
};

// 切换链接分享状态
export const resetShareLink = async (data) => {
  return http.post('/dashboard-share/reset-share-link', data);
};

// 取消对部分用户的分享
export const getCancelUserShare = async (data) => {
  return http.post('/dashboard-share/cancel-user-share-page', data);
};

// 获取指定仪表盘的分享信息
export const getShareInfo = async (data) => {
  return http.post('/dashboard-share/get-share-page-info', data);
};


// 查询组件分类列表
export const getWidgetCategory = async (data) => {
  return http.post('/sys-home/list/widget/category', data);
};
// 获取仪表盘分享用户聚合信息
export const getDashboardShareUserAssemble = async (data) => {
  return http.post('/dashboard-share/share-users-assemble', data);
};
/**
 * 燃起图组件-获取配置信息
 * @param data
 * @returns {Promise<*>}
 */
export const getBurnupConfig = async (data) => {
  return http.post('/sys-home/get/burn-up-config', data);
};

/**
 * 燃起图组件-获取项目下的迭代信息
 * @param data
 * @returns {Promise<*>}
 */
export const getBurnupProjectSprintInfo = async (data) => {
  return http.post('/project-list/burn-config', data);
};

/**
 * 燃起图组件-获取迭代信息
 * @param data
 * @returns {Promise<*>}
 */
export const getBurnupSprintInfo = async (data) => {
  return http.post('/sprint/query-sprint-count-detail', data);
};

/**
 * 燃起图组件-获取版本信息
 * @param id
 * @returns {Promise<*>}
 */
export async function getBurnupVersionInfo (id) {
  return http.post(`release/detail/get/${id}`);
}

// 全局设置查询迭代
export const listRecommendByProjectId = async (data) => {
  return http.post('/sprint/list-recommend-by-project-id', data);
};
//仪表盘批量保存
export const batchUpdateWidget = async (data) => {
  return http.post('/sys-home/batch-update-widget', data);
};
//根据角色推荐仪表盘
export const initRoleWidget = async () => {
  return http.post('/sys-home/init-role-widget');
};

// 获取codingTime筛选条件下拉选择项
export const getCodingTimeFilterOptions = async() => {
  return http.post('/ide-coding-time-widget/coding-time-condition', {});
};

//查询团队用时分布相关数据
export const queryTeamCodingTimeWidget = async(data) => {
  return http.post('/ide-coding-time-widget/query-team-coding-time', data);
};

//查询成员用时分布相关数据
export const queryAssigneeCodingTimeWidget = async(data) => {
  return http.post('/ide-coding-time-widget/query-assignee-coding-time', data);
};

// 获取仪表盘分享数据
export const getShareDashboard = async(url) => {
  return http.get(`/dashboard-share/get-share-dashboard?code=${url}`, {}, {
    showError: false
  });
};

// 获取个人仪表盘分享者的数量
export const getDashboardPageUserCount = async(data) => {
  return http.post(`/dashboard-share/query-share-page-user-count`, data);
};
